import React from 'react';
import cn from 'classnames';

import { IWidgetCustomization } from 'widget/entities/config';
import { LayoutVersion, Placement } from 'widget/types/common';
import CrossIcon from 'widget/shared/icons/CrossIcon';
import { IconColor, IconSize } from 'widget/shared/icons/BaseIcon';
import IconButton from 'widget/shared/ui/IconButton';
import { WidgetTexts } from 'widget/consts/texts';

import WidgetToggle from './WidgetToggle';
import WidgetDesktopChannels from './WidgetDesktopChannels';
import styles from './WidgetAside.module.scss';

export type WidgetAsideProps = {
  layout: LayoutVersion;
  isOpen?: boolean;
  onToggle?: () => void;
  onHideUntilReload?: () => void;
  className?: string;
  customizationConfig?: IWidgetCustomization;
  placement?: Placement;
};

const WidgetAside: React.FC<WidgetAsideProps> = ({
  layout,
  isOpen,
  onToggle,
  onHideUntilReload,
  className,
  customizationConfig
}) => {
  const isDesktop = layout === LayoutVersion.DESKTOP;

  const handleHideUntilReload = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.preventDefault();
      event.stopPropagation();
      onHideUntilReload?.();
    },
    [onHideUntilReload]
  );

  return (
    <div className={cn(styles['widget-aside'], className)}>
      {!isOpen && onHideUntilReload && (
        <IconButton
          aria-label={WidgetTexts.widgetLauncher.hideUntilReload}
          onClick={handleHideUntilReload}
          className={styles['widget-aside__hide-button']}
        >
          <CrossIcon color={IconColor.Inherit} size={IconSize.XXS} />
        </IconButton>
      )}
      <WidgetDesktopChannels
        channels={customizationConfig?.channels}
        isVisible={!!isOpen && isDesktop}
      />
      <WidgetToggle
        isOpen={isOpen}
        onClick={onToggle}
        buttonConfig={customizationConfig?.button}
      />
    </div>
  );
};

export default WidgetAside;
